var _path, _g, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_16337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 68C55.464 68 68 55.464 68 40C68 24.536 55.464 12 40 12C24.536 12 12 24.536 12 40C12 55.464 24.536 68 40 68ZM40 56C48.8366 56 56 48.8366 56 40C56 31.1634 48.8366 24 40 24C31.1634 24 24 31.1634 24 40C24 48.8366 31.1634 56 40 56Z",
    fill: "#C1CCF4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_16337)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 4,
    width: 36,
    height: 36,
    fill: "#C1CCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 64.5L30.5 71.5L54.5 77L40 40L18 64.5Z",
    fill: "#C1CCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11L-16 31.5L4 86.5L40 40L20.5 11Z",
    fill: "#A6B6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 4L27 -0.5L17 7.5L40 40V4Z",
    fill: "#E0E5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 75L70.5 66.5L76 40H40L52 75Z",
    fill: "#A6B6EF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 10,
    fill: "#17C5D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 58C63.25 58.6904 62.6904 59.25 62 59.25C61.3096 59.25 60.75 58.6904 60.75 58C60.75 57.3096 61.3096 56.75 62 56.75C62.6904 56.75 63.25 57.3096 63.25 58Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61.5V66",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.7b8967202def1d744d7dfebc33972854.svg";
export { ForwardRef as ReactComponent };